import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import { rideAutofocusAtom } from '../../RidePlayer/RidePlayerState';
import { autofocusAtom, isRidePlayerOpenAtom, vehicleFocusAtom } from '../OnlineMapState';
import useAnalytics from '../../../hooks/useAnalytics';

export default function VehicleFocus(): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [rideAutofocus, setRideAutofocus] = useRecoilState<boolean>(rideAutofocusAtom);
  const [vehicleFocus, setVehicleFocus] = useRecoilState<boolean>(vehicleFocusAtom);
  const [autofocus, setAutofocus] = useRecoilState<boolean>(autofocusAtom);
  const isRidePlayerOpen = useRecoilValue<number | boolean>(isRidePlayerOpenAtom);
  const { trackEvent } = useAnalytics();

  const handleChangeVehicleFocus = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    trackEvent(['map', 'click', 'Focus on Vehicle']);
    if (autofocus && !isRidePlayerOpen) {
      setAutofocus(false);
    }
    if (isRidePlayerOpen && rideAutofocus) {
      setRideAutofocus(false);
    }
    setVehicleFocus(!vehicleFocus);
  };

  return (
    <a
      onClick={handleChangeVehicleFocus}
      title={f({ id: 'map.focusontarget' })}
      data-cy="controls-on-map-focusontarget"
      className={`${vehicleFocus ? 'e-button-sq text-primary' : 'e-button-sq'}`}
    >
      <i className="cmd-icon cmd-icon-zoom-out-map" />
    </a>
  );
}
